import { Component, Input, OnInit, Output, OnChanges, SimpleChanges, EventEmitter, ViewChild } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { SdkService }  from "../../services/sdk.service";
import { SharedService }  from "../../services/shared.service";
import { BrandProfileService } from '../../services/brand-profile.service';
import { EventEmitterService } from '../../services/event-emitter.service';
import { IDisbursementSession } from '../../interfaces/disbursement-session';
import { IBrandProfile } from 'src/app/interfaces/brand-profile';
import { IStateProvince } from '../../interfaces/state-province';
import { IPageHeader } from '../../interfaces/page-header';
import { IPageContent } from '../../interfaces/page-content';
import { BrandHeaderComponent } from '../../components/brand-header/brand-header.component';
import { faUniversity, faCalendar, faAddressCard, faHome, faCity } from '@fortawesome/free-solid-svg-icons';
import { faCoffee, faBuilding, faEnvelopeOpen, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
// import { TextMaskModule } from 'angular2-text-mask';

@Component({
  selector: 'app-funding-account-ach',
  templateUrl: './funding-account-ach.component.html',
  styleUrls: ['./funding-account-ach.component.css']
})
export class FundingAccountAchComponent implements OnInit, OnChanges {

  // @Input() sessionId: string = '';
  // @Input() bAch: boolean = false;
  // @Input() disbursementSession: any;
  // @Input() brandProfile?: IBrandProfile;

  envRegion!: string;
  disbursementSession!: IDisbursementSession;
  brandProfile!: IBrandProfile;

  @ViewChild(BrandHeaderComponent, {static : true}) child! : BrandHeaderComponent;
  @Output() cancelAch: EventEmitter<string> = new EventEmitter<string>();

  public brandStyleTheme: any = {};

  headerData!: IPageHeader;
  // achForm = new FormGroup({});
  achForm: FormGroup;

  pageContent!: IPageContent;

  sessionIdKnown: boolean = false;

  billerAccountId: string = '';
  transactionType: string = '';
  accountTypes = [
    {code: 'PersonalChecking', literal: 'Personal Checking' },
    {code: 'PersonalSavings', literal: 'Personal Savings' },
    {code: 'BusinessChecking', literal: 'Business Checking' },
    {code: 'BusinessSavings', literal: 'Business Savings' }
  ];
  selectedAccountType?: string;

  stateProvinces!: IStateProvince[];

  isDsbMessageShown: boolean = false;
  dsbMessage: string = '';

  faAddressCard = faAddressCard;
  faUniversity = faUniversity;
  faCalendar = faCalendar;
  faHome = faHome;
  faBuilding = faBuilding;
  faEnvelopeOpen = faEnvelopeOpen;
  faCoffee = faCoffee
  faBriefcase = faBriefcase;
  faCity = faCity;

  public constructor(
    private router: Router,
    private fb: FormBuilder,
    private sdkService: SdkService,
    private sharedService: SharedService,
    private brandProfileService: BrandProfileService,
    private eventEmitterService: EventEmitterService
    ) {
      // console.log('FundingAccountAchComponent', 'constructor');
      this.achForm = this.fb.group({
        'routing-number': new FormControl('', [Validators.required]),
        'account-number': new FormControl('', [Validators.required]),
        'bank-account-type': new FormControl('dummy', [Validators.required]),
        'account-holder-name': new FormControl(''),
        'funding-account-nickname': new FormControl(''),
        'account-address-line1': new FormControl(''),
        'account-city': new FormControl(''),
        'account-region-code': new FormControl(''),
        'account-postal-code': new FormControl(''),
        'single-use': new FormControl(true),
        'errMessage': new FormControl('')
      });
    }

    ngOnInit(): void {
      // console.log('FundingAccountAchComponent', 'ngOnInit');

      // Get the current enviromental region
      this.envRegion = this.sharedService.getEnvRegion();

      // Get the current brand profile
      if (this.sharedService.getBrandProfile()) {
        this.brandProfile = this.sharedService.getBrandProfile();
      } else {

      }

      // Make preparations for the page generic content
      this.pageContent = {
        headerTitle: this.sharedService.getCustomizedTitle('APP_TITLE') || '',
        headerSubtitle: this.sharedService.getCustomizedTitle('ACH') || '',
        headerAvatar: 'bank.svg'
      }

      // Get the current disbursement session
      this.disbursementSession = this.sharedService.getDisbursementSession();

      // if (this.brandProfile) {
      //   this.child.makeBrandHeader(this.brandProfile, pageContent);
      //   this.brandStyleTheme = this.sharedService.getBrandStyleScheme(this.brandProfile);
      // }

      // Apply the brand's style scheme
      if (this.brandProfile) {
        this.brandStyleTheme = this.sharedService.getBrandStyleScheme(this.brandProfile);
      }
  //      this.headerData = {headerText: 'Add ACH', brandProfile: {brandCode: 'lob', brandName: 'Lobel Financial'}, headerImage: "bank.svg"};
      // if (this.brandProfile) {
      //   this.headerData = {
      //     headerText: 'Add ACH',
      //     brandProfile: this.brandProfile,
      //     headerImage: "bank.svg"
      //   };
      // }

      // do we need to remove any account types from the list if they are not configured for the biller?
      if (this.disbursementSession) {
        // console.log(this.disbursementSession.fundingAccountTypes);
        if (this.disbursementSession.fundingAccountTypes) {
          this.accountTypes = this.disbursementSession.fundingAccountTypes;
        }

        // if (this.disbursementSession.fundingAccountTypes) {
        //   this.disbursementSession.fundingAccountTypes.forEach (item => {
        //     this.accountTypes.push({code: item., literal: 'Personal Checking' });
        //   })
        // }

        // Initiliaize the SDK gateway
        try {
          this.sdkService.initGateway(this.envRegion, this.disbursementSession, 'ACH', this.achForm);
        } catch (e: any){
            // console.log(e);
            alert(e);
        } finally {
            // console.log('finally');
        }
      }

      // Get a list of state provinces
      this.getStateProvinces();   
      
      // Subscribe to possible exception events
      this.eventEmitterService.invokeAchFundingAccountExceptionEvent.subscribe(message => {
        // console.log('funding-account-ach - onInit - subscription', message);
        this.dsbMessage = message;
        if (message) {
          this.isDsbMessageShown = true;
        } else {
          this.isDsbMessageShown = false;
        }
      }); 
      
      this.eventEmitterService.invokeAchElementValueChanged.subscribe( () =>{
        this.closeDsbMessage();
      });      
    }

    private getStateProvinces() {
      this.brandProfileService.getStatesProvinces()
      .subscribe({
        next: (response) => {
          this.stateProvinces = response;
        },
        error: (e) => {
        },
        complete: () => {
        }
      });
    }      

    changeAccountType(e: any) {
      // console.log(e.target.value);
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    onCancel() {
      //this.cancelCard.emit('');
      this.router.navigate(['/dsb-funding-accounts']);
    }

    closeDsbMessage() {
      this.dsbMessage = '';
      this.isDsbMessageShown = false;
    }

  }
